// domain/exportPolicy — siapa boleh export (anti-pencurian DB). Murni + testable.
// O/M bebas · SPV via approval single-use · Finance/CS/Teknisi/Supplier TIDAK.
export function canExportDirect(role: string): boolean {
  return role === 'Owner' || role === 'Manager';
}
export function canRequestExport(role: string): boolean {
  return role === 'SPV';
}
/** Peran boleh export sama sekali (langsung ATAU via approval). Selain ini: tombol export sia-sia. */
export function mayExportAtAll(role: string): boolean {
  return canExportDirect(role) || canRequestExport(role);
}
